import { render } from "./ModalCopyPaste.vue?vue&type=template&id=39630ac1&scoped=true"
import script from "./ModalCopyPaste.vue?vue&type=script&lang=js"
export * from "./ModalCopyPaste.vue?vue&type=script&lang=js"

import "./ModalCopyPaste.vue?vue&type=style&index=0&id=39630ac1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39630ac1"]])

export default __exports__